import {CombatantOptions} from "@/tabletop/tokens/edit/CombatantOptions.tsx";
import MultiCombatantOptions from "@/tabletop/tokens/edit/MultiCombatantOptions.tsx";
import {useTableTopSelection} from "@/tabletop/selection/TableTopSelectionHooks.ts";
import type {Visibility} from "@/tabletop/visibility/VisibilityModel.ts";

export default function TableTopPropertiesView({visibility}: {
    visibility: Visibility;
}) {
    const {selectedCombatants} = useTableTopSelection()

    if (selectedCombatants.length === 1) {
        return <CombatantOptions key={selectedCombatants[0].id}
                                 combatant={selectedCombatants[0]} visibility={visibility}/>;
    }
    if (selectedCombatants.length > 1) return <MultiCombatantOptions/>;
    return null;
}
